import React from 'react';

import { CardListFilterMenu } from '@vlabs/monokit/entities/cards/filters';

import { useListTypeContext } from '../ListTypeContext';
import { ListFacesFilterMenu } from './faces-filters';

export function ListDetailsFilterMenu(): React.JSX.Element {
  const { listType } = useListTypeContext();
  return (
    <React.Fragment>
      {listType === 'cards' && <CardListFilterMenu exclude={['list_ids']} />}
      {listType === 'faces' && <ListFacesFilterMenu />}
    </React.Fragment>
  );
}
